// import { useEffect, useState } from "react";
// import ImageWithSkeleton from "../components/ImageWithSkeleton";
// import GallerySkeleton from "../components/GallerySkeleton";

// const ImageGallery = () => {
//   const [loading, setLoading] = useState(true);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const galleryImages = [
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758598472/gallery_2_po3kqu.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758598471/gallery_5_c6jqy0.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758598470/gallery_6_uxnbdp.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758598470/gallery_4_qzvjxa.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758598469/gallery_7_jdgayf.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022704/IMG_0717-min_hotfq8.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022704/IMG_8395-min_ukxech.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022704/IMG_8407-min_oziyyu.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022701/IMG_0653-min_cdiehq.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022701/IMG_8404-min_fsjpm8.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022698/IMG_8467-min_qcnnul.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755022698/IMG_2777-min_vi5jxy.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754940458/DJI_20250811170117_0281_D-min_vbjo1e.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758598472/gallery_1_vkpjcu.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708197/gal_18_bi2lqp.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708190/gal_20_ltmhlw.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708190/gal_13_buimmq.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708187/gal_22_zuam8c.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708186/gal_12_ksxaw0.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708187/gal_21_ahxhfj.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708186/gal_15_vnmcit.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708185/gal_10_smffbx.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708184/gal_14_ev3lzh.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708184/gal_24_yqpsvt.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708180/gal_11_unpj53.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708178/gal_33_qasn58.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708175/gal_8_cgllsw.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708175/gal_30_icbpvm.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708175/gal_29_avr3ic.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708174/gal_34_pxuklk.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708173/gal_32_cavsnd.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708171/gal_31_zlplqy.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708170/gal_27_n33jtd.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708170/gal_17_wycqrb.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708170/gal_28_ckzycc.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708169/gal_19_mxpc4w.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708167/gal_16_qw9qnb.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708166/gal_26_gxi8nj.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708164/gal_9_atrlmm.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708165/gal_25_mt3m4g.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708162/gal_23_ilyrew.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708161/gal_4_lczfmx.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708161/gal_1_jxhuqv.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708160/gal_2_am8vpg.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708159/gal_6_wyzoas.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708159/gal_5_dxrhft.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708156/gal_3_ishykt.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758708155/gal_7_iqqipe.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507967/winter_cup_1_t3mr4t.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507966/winter_cup_6_lzkvo5.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507970/winter_cup_2_jeluhs.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507968/winter_cup_11_p1xnxn.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507970/winter_cup_4_qpecrh.png",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507967/winter_cup_10_eqq8fs.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507968/winter_cup_5_jm6pxm.png",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507965/winter_cup_8_zgjnpd.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507965/winter_cup_9_fuptas.jpg",
// "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759507966/winter_cup_7_w36fkc.jpg",
//   ];

//   // Simulate fetch delay
//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   const openLightbox = (index) => {
//     setSelectedImage(galleryImages[index]);
//     setCurrentIndex(index);
//   };

//   const closeLightbox = () => {
//     setSelectedImage(null);
//   };

//   const navigateImage = (direction) => {
//     let newIndex;
//     if (direction === "prev") {
//       newIndex =
//         (currentIndex - 1 + galleryImages.length) % galleryImages.length;
//     } else {
//       newIndex = (currentIndex + 1) % galleryImages.length;
//     }
//     setCurrentIndex(newIndex);
//     setSelectedImage(galleryImages[newIndex]);
//   };

//   return (
//     <section className="py-16 px-4 md:px-20 bg-white">
//       <h2 className="text-3xl font-bold text-center mb-12 uppercase">
//         RGCC Image Gallery
//       </h2>

//       {/* <div className="columns-2 md:columns-3 gap-4"> */}
//       {loading ? (
//         // 👇 show skeleton grid while data loads
//         <GallerySkeleton />
//       ) : (
//         <div
//           className={`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 transition-opacity duration-700 ${
//             loading ? "opacity-0" : "opacity-100"
//           }`}
//         >
//           {galleryImages.map((image, index) => (
//             <div
//               key={index}
//               className="relative mb-4 cursor-pointer group inline-block"
//               onClick={() => openLightbox(index)}
//             >
//               <ImageWithSkeleton
//                 src={image}
//                 alt={`Gallery ${index + 1}`}
//                 className="w-full h-48 object-cover rounded-md transition-transform duration-500 group-hover:scale-105"
//               />

//               <div className="absolute inset-0 flex items-center justify-center bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300">
//                 <svg
//                   className="w-10 h-10 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
//                   />
//                 </svg>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {selectedImage && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
//           <button
//             onClick={closeLightbox}
//             className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &times;
//           </button>

//           <button
//             onClick={() => navigateImage("prev")}
//             className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10094;
//           </button>

//           <div className="max-w-4xl w-full">
//             <img
//               src={selectedImage}
//               alt="Selected"
//               className="w-full max-h-[80vh] object-contain"
//             />
//           </div>

//           <button
//             onClick={() => navigateImage("next")}
//             className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10095;
//           </button>

//           <div className="absolute bottom-4 text-white">
//             {currentIndex + 1} / {galleryImages.length}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default ImageGallery;
import { useEffect, useState } from "react";
import ImageWithSkeleton from "../components/ImageWithSkeleton";
import GallerySkeleton from "../components/GallerySkeleton";
import axios from "axios";

// const BACKEND_URL = "http://localhost:8081";
const BACKEND_URL = "https://api.rangpurgolf.com";

const ImageGallery = () => {
  const [loading, setLoading] = useState(true);
  const [galleryImages, setGalleryImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // ✅ Fetch images from backend
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/media/get/all`, {
          params: { type: "IMAGE_GALLERY" },
        });
        setGalleryImages(res.data.map((item) => item.url)); // assuming MediaFileEntity has `url` field
      } catch (err) {
        console.error("Error fetching images:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  const openLightbox = (index) => {
    setSelectedImage(galleryImages[index]);
    setCurrentIndex(index);
  };

  const closeLightbox = () => setSelectedImage(null);

  const navigateImage = (direction) => {
    let newIndex;
    if (direction === "prev") {
      newIndex =
        (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    } else {
      newIndex = (currentIndex + 1) % galleryImages.length;
    }
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  return (
    <section className="py-16 px-4 md:px-20 bg-white">
      <h2 className="text-3xl font-bold text-center mb-12 uppercase">
        RGCC Image Gallery
      </h2>

      {loading ? (
        <GallerySkeleton />
      ) : (
        <div
          className={`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 transition-opacity duration-700 ${
            loading ? "opacity-0" : "opacity-100"
          }`}
        >
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="relative mb-4 cursor-pointer group inline-block"
              onClick={() => openLightbox(index)}
            >
              <ImageWithSkeleton
                src={image}
                alt={`Gallery ${index + 1}`}
                className="w-full h-48 object-cover rounded-md transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300">
                <svg
                  className="w-10 h-10 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ✅ Lightbox unchanged */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
          >
            &times;
          </button>

          <button
            onClick={() => navigateImage("prev")}
            className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
          >
            &#10094;
          </button>

          <div className="max-w-4xl w-full">
            <img
              src={selectedImage}
              alt="Selected"
              className="w-full max-h-[80vh] object-contain"
            />
          </div>

          <button
            onClick={() => navigateImage("next")}
            className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
          >
            &#10095;
          </button>

          <div className="absolute bottom-4 text-white">
            {currentIndex + 1} / {galleryImages.length}
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGallery;
